import { render, staticRenderFns } from "./mdModalEditTPBehavioral.vue?vue&type=template&id=2796cec8&"
import script from "./mdModalEditTPBehavioral.vue?vue&type=script&lang=js&"
export * from "./mdModalEditTPBehavioral.vue?vue&type=script&lang=js&"
import style0 from "./mdModalEditTPBehavioral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports